import React from 'react';
import PropTypes from 'prop-types';
import styles from './FormRow.module.css';

const FormRow = ({ children }) => {
return <div className={styles.formRow}>{children}</div>;
};

FormRow.propTypes = {
  children: PropTypes.node
};

export default FormRow;